//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibFindOutMore',
  data: function data() {
    return {
      showModal: false,
      slide: '1',
      hardcodedPics: ['https://i.picsum.photos/id/102/500/500.jpg', 'https://i.picsum.photos/id/102/500/500.jpg', 'https://i.picsum.photos/id/1/500/500.jpg']
    };
  },
  methods: {
    getStartedClicked: function getStartedClicked() {
      this.showModal = false;
      this.reset();
    },
    onClose: function onClose() {
      this.showModal = false;
      this.reset();
    },
    reset: function reset() {
      this.slide = '1';
    }
  }
};